import { Action, combineReducers } from "redux";
import { IUsersPage } from "source/models/user/usersPage";

// State
export interface IUserPageState {
    dataId: number;
    usersPage: IUsersPage;
}

export interface IUserState {
    page: IUserPageState;
}

// Action type constants
const USER_SUCCESS = "USER_SUCCESS";
const USER_FAILURE = "USER_FAILURE";

type T_USER_SUCCESS = typeof USER_SUCCESS;
type T_USER_FAILURE = typeof USER_FAILURE;

// Action types
interface IUserSuccess extends Action {
    type: T_USER_SUCCESS;
    usersPage: IUsersPage;
}

interface IUserFailure extends Action {
    type: T_USER_FAILURE;
}

export type UserAction =
    | IUserSuccess
    | IUserFailure;

//Actions
export const userSuccess = (usersPage: IUsersPage): IUserSuccess => ({
    type: USER_SUCCESS,
    usersPage
});

export const userFailure = (): IUserFailure => ({
    type: USER_FAILURE
});

//Reducers
export const userInitialState: IUserState = {
    page: {
        dataId: 0,
        usersPage: null
    }
};

const page = (state: IUserPageState = null, action: UserAction) => {
    switch (action.type) {
    case USER_SUCCESS: {
        const userSuccess = action as IUserSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            usersPage: userSuccess.usersPage
        };
    }
    case USER_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const userReducer = combineReducers({
    page
});

//Utils